<template>
  <div class="bg">
    <div class="flex flex-row pt-5 items-center justify-between mx-10 lg:mx-20">
      <router-link to="/" class="flex space-x-3 items-center">
        <img
          src="@/assets/logo.png"
          alt="TBRI Logo"
          class="w-16 h-16 test-logo"
        />
        <div class="text-left w-full hidden md:block">
          <h1 class="text-2xl font-bold text-white">
            農業部生物多樣性研究所植物標本館(TAIE)
          </h1>
          <span class="text-xl text-white"
            >Herbarium of Taiwan Biodiversity Research Institute</span
          >
        </div>
      </router-link>
      <div class="flex space-x-10 items-center">
        <a
          target="_blank"
          title="GBIF連結"
          alt="GBIF連結"
          rel="noreferrer noopener"
          class="backend"
          href="https://scientific-collections.gbif.org/institution/e7cc8ec2-370a-4d9c-b2eb-ee58e2016106"
        >
          <img
            src="@/assets/gbif.png"
            alt="GRSciColl icon"
            class="test-tool"
            style="width:48px;height:48px"
          />
        </a>

        <a
          target="_blank"
          title="進入管理系統"
          alt="後台管理"
          rel="noreferrer noopener"
          id="test-tesri"
          class="backend"
          @click="getLink"
        >
          <img src="@/assets/tool.svg" alt="後台管理" class="test-tool" />
        </a>

        <div v-if="!loggedIn">
          <a href="/login" id="test-login" title="登入">
            <LoginIcon class="w-11 h-11 text-gray-50" />
          </a>
        </div>
        <div v-else>
          <div class="cursor-pointer" @click="logout" title="登出">
            <LogoutIcon class="w-11 h-11 text-gray-50" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthMixins from '@/mixins/auth';
import { LoginIcon, LogoutIcon } from "@heroicons/vue/outline";

export default {
  mixins: [AuthMixins],
  components: {
    LoginIcon,
    LogoutIcon,
  },
  methods: {
    async logout() {
      await this.$store.dispatch('user/logout');
      this.$toast.default("Log out successfully");
      this.$router.push("/");
    },
    getLink() {
      const API_URL = (typeof config === "undefined" ? process.env.VUE_APP_BACKEND_WEB : config.VUE_CONFIG_APP_BACKEND || process.env.VUE_APP_BACKEND_WEB)
      window.open(API_URL, '_blank')
    }
  },
};
</script>

<style>
.bg {
  height: 100px;
  background-color: #66849c;
}
.backend {
  cursor: pointer;
}
</style>
